// --- START OF FILE App.js ---
import './App.css'; // Make sure your global CSS is imported
import React, { useEffect, useState } from 'react';
import { ConfigProvider, theme, Layout, Typography } from 'antd';
// Import useLocation to check the current path
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';

import PDRCalculator from './components/calculators/pdrCalc';
import QuestTracker from './components/Quests/questtracker';
import DadMenu from './components/DadMenu';
import MapSelector from './components/map/mapMain';
import HomePage from './components/homePage';
import ReactGA from 'react-ga4';
import { IconProvider } from './components/map/iconContext';
import QuestItems from './components/Quests/questitems';
import {
  calcEhpPath,
  questTrackerPath,
  mapSelectorPath, // Ensure this path constant is correct
  questItemsPath,
} from './data/paths';

const { Content, Footer, Sider } = Layout;

// Create a component to wrap the main layout logic, so we can use useLocation
function AppLayout() {
  const location = useLocation(); // Get current location object
  const [menuCollapsed, setMenuCollapsed] = useState(false);
  const [characters, setCharacters] = useState(null);
  const [selectedCharacter, setSelectedCharacter] = useState(null);

  // ... (keep all the state setters and useEffect for loading data as before) ...
  const setAndStoreDadMenuCollapsed = (value) => { localStorage.setItem('isDadMenuCollapsed', JSON.stringify(value)); setMenuCollapsed(value); };
  const setAndStoreCharacters = (value) => { localStorage.setItem('characters', JSON.stringify(value)); setCharacters(value); };
  const setAndStoreSelectedCharacter = (value) => { localStorage.setItem('selectedCharacter', JSON.stringify(value)); setSelectedCharacter(value); };

  useEffect(() => {
      ReactGA.initialize('G-PJ8G13VXEE');
      const storedIsDadMenuCollapsedState = localStorage.getItem('isDadMenuCollapsed');
      if (storedIsDadMenuCollapsedState != null) { try { setMenuCollapsed(JSON.parse(storedIsDadMenuCollapsedState)); } catch (e) { /* ignore error */ } }
      const storedCharacters = localStorage.getItem('characters');
      if (storedCharacters != null) {
          try {
              const parsedChars = JSON.parse(storedCharacters); setCharacters(parsedChars);
              const storedSelectedCharacter = localStorage.getItem('selectedCharacter');
              if (storedSelectedCharacter != null) { const parsedSelected = JSON.parse(storedSelectedCharacter); if (parsedChars?.some(char => char.name === parsedSelected)) { setSelectedCharacter(parsedSelected); } else if (parsedChars?.length > 0) { const firstCharName = parsedChars[0].name; setSelectedCharacter(firstCharName); localStorage.setItem('selectedCharacter', JSON.stringify(firstCharName)); } else { setSelectedCharacter(null); } }
              else if (parsedChars?.length > 0) { const firstCharName = parsedChars[0].name; setSelectedCharacter(firstCharName); localStorage.setItem('selectedCharacter', JSON.stringify(firstCharName)); }
          } catch(e) { const defaultChars = [{ name: 'Timmy', class: 'Fighter' }]; setCharacters(defaultChars); setSelectedCharacter(defaultChars[0].name); }
      } else { const defaultChars = [{ name: 'Timmy', class: 'Fighter' }]; setCharacters(defaultChars); setSelectedCharacter(defaultChars[0].name); localStorage.setItem('characters', JSON.stringify(defaultChars)); localStorage.setItem('selectedCharacter', JSON.stringify(defaultChars[0].name)); }
  }, []);


  if (characters === null) {
    return <div style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#222831', color: '#eee'}}>Loading...</div>;
  }

  // Determine if the footer should be shown based on the current path
  const showFooter = location.pathname !== mapSelectorPath;

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <DadMenu
        characters={characters}
        setAndStoreCharacters={setAndStoreCharacters}
        selectedCharacter={selectedCharacter}
        setAndStoreSelectedCharacter={setAndStoreSelectedCharacter}
        menuCollapsed={menuCollapsed}
        setMenuCollapsed={setAndStoreDadMenuCollapsed}
      />
      <Layout style={{ height: '100vh', overflow: 'hidden' }}>
        <Content style={{ height: '100%', overflow: 'hidden', padding: 0, margin: 0 }}>
            <Routes>
              {/* Non-map routes */}
              <Route path="/" element={<div style={{padding: 24, height: '100%', overflowY: 'auto'}}><HomePage /></div>} />
              <Route path={calcEhpPath} element={<div style={{padding: 24, height: '100%', overflowY: 'auto'}}><PDRCalculator /></div>} />
              <Route path={questTrackerPath} element={<div style={{padding: 24, height: '100%', overflowY: 'auto'}}><QuestTracker characters={characters} setAndStoreCharacters={setAndStoreCharacters} selectedCharacter={selectedCharacter} /></div>} />
              <Route path={questItemsPath} element={<div style={{padding: 24, height: '100%', overflowY: 'auto'}}><QuestItems characters={characters} setAndStoreCharacters={setAndStoreCharacters} selectedCharacter={selectedCharacter} /></div>} />

              {/* Map Route - Fills height, no internal padding */}
              <Route
                path={mapSelectorPath}
                element={
                  <div style={{ height: '100%', width: '100%' }}> {/* Container for MapSelector */}
                      <IconProvider>
                        <MapSelector
                          characters={characters}
                          setAndStoreCharacters={setAndStoreCharacters}
                          selectedCharacter={selectedCharacter}
                        />
                      </IconProvider>
                   </div>
                }
              />
            </Routes>
        </Content>

        {/* --- CONDITIONAL FOOTER --- */}
        {showFooter && (
          <Footer style={{ textAlign: 'center', padding: '10px 24px', flexShrink: 0, background: '#222831' /* Match base background */ }}>
            Game content and materials © Ironmace. This site is not affiliated with Ironmace.
            <br/>
            ©{new Date().getFullYear()} Created by Awkward & Dbleh
          </Footer>
        )}
        {/* --- END CONDITIONAL FOOTER --- */}

      </Layout>
    </Layout>
  );
}


// App component now wraps everything in BrowserRouter and ConfigProvider
function App() {
  return (
     <ConfigProvider
       theme={{
         algorithm: theme.darkAlgorithm,
         token: { colorPrimary: '#76ABAE', colorInfo: '#ffd400', colorBgBase: '#222831', colorTextBase: '#EEEEEE', },
         components: { Table: { cellPaddingBlock: 8, }, },
       }}
     >
       <BrowserRouter>
          <AppLayout /> {/* Render the component that can use useLocation */}
       </BrowserRouter>
     </ConfigProvider>
  )
}


export default App;
// --- END OF FILE App.js ---